import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const purchases = [{
  name: 'María L.',
  location: 'Buenos Aires',
  time: 'hace 3 min'
}, {
  name: 'Carolina S.',
  location: 'Córdoba',
  time: 'hace 5 min'
}, {
  name: 'Luciana R.',
  location: 'Rosario',
  time: 'hace 8 min'
}, {
  name: 'Valentina G.',
  location: 'Mendoza',
  time: 'hace 12 min'
}, {
  name: 'Florencia M.',
  location: 'La Plata',
  time: 'hace 15 min'
}, {
  name: 'Agustina P.',
  location: 'Tucumán',
  time: 'hace 18 min'
}, {
  name: 'Camila D.',
  location: 'Mar del Plata',
  time: 'hace 22 min'
}, {
  name: 'Julieta B.',
  location: 'Salta',
  time: 'hace 25 min'
}, {
  name: 'Rocío T.',
  location: 'Santa Fe',
  time: 'hace 30 min'
}, {
  name: 'Daniela V.',
  location: 'Neuquén',
  time: 'hace 35 min'
}, {
  name: 'Paula H.',
  location: 'San Juan',
  time: 'hace 40 min'
}, {
  name: 'Milagros F.',
  location: 'Bahía Blanca',
  time: 'hace 45 min'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const showDelay = setTimeout(() => {
      setVisible(true);
    }, 4000);
    return () => clearTimeout(showDelay);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed || !visible) return;
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 5000);
    const nextTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % purchases.length);
      setVisible(true);
    }, 8000);
    return () => {
      clearTimeout(hideTimer);
      clearTimeout(nextTimer);
    };
  }, [visible, currentIndex, dismissed]);
  if (dismissed) return null;
  const purchase = purchases[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50" data-id="element-162" data-mp="1h5tdpnmy77gm">
      <AnimatePresence data-id="element-163" data-mp="1m3l8qqiw39p1">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        duration: 0.4,
        ease: 'easeOut'
      }} className="bg-[#1A1A1A] border border-[#C084FC]/30 rounded-xl shadow-2xl shadow-black/40 px-4 py-3 max-w-xs" data-id="element-164" data-mp="1m4d3y08kr5es">
            <button onClick={() => setDismissed(true)} className="absolute top-2 right-2 text-gray-500 hover:text-gray-300 transition-colors" aria-label="Cerrar notificación" data-id="element-165" data-mp="2er7k4kyczimg">
              <XIcon className="w-3.5 h-3.5" data-id="element-166" data-mp="kehq837zq9f2" />
            </button>

            <div className="flex items-start gap-3 pr-4" data-id="element-167" data-mp="cvrydpl82x3i">
              <div className="flex-shrink-0 mt-0.5" data-id="element-168" data-mp="8409djhpszfh">
                <div className="w-9 h-9 rounded-full bg-[#C084FC]/20 flex items-center justify-center" data-id="element-169" data-mp="82fchn7xh4eg">
                  <CheckCircleIcon className="w-5 h-5 text-[#C084FC]" data-id="element-170" data-mp="35f3p4jp1njn" />
                </div>
              </div>
              <div className="min-w-0" data-id="element-171" data-mp="3ud1ctcp6mi7w">
                <p className="text-sm text-white font-semibold font-['Open_Sans',_sans-serif] leading-tight" data-id="element-172" data-mp="vu4a9j3iql2s">
                  {purchase.name}
                  <span className="text-gray-400 font-normal" data-id="element-173" data-mp="qv13nu7w46sp"> de </span>
                  {purchase.location}
                </p>
                <p className="text-xs text-[#C084FC] mt-0.5 font-['Open_Sans',_sans-serif]" data-id="element-174" data-mp="lx7waxuup6qu">
                  adquirió el Megapack 🧠
                </p>
                <p className="text-[10px] text-gray-500 mt-1" data-id="element-175" data-mp="36mf6bputt600">
                  {purchase.time}
                </p>
              </div>
            </div>

            <div className="mt-2 flex items-center gap-1.5" data-id="element-176" data-mp="ubcbydmgaz5l">
              <div className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" data-id="element-177" data-mp="ua1aikgha3hn" />
              <span className="text-[10px] text-gray-500" data-id="element-178" data-mp="z2ucx1oh4zqk">
                +2.400 profesionales ya lo tienen
              </span>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}